import "animate.css";
import "animate.css/animate.min.css";
import { cssTransition } from "react-toastify";

export const bounce = cssTransition({
  enter: "animate__animated animate__fadeInRightBig",
  exit: "animate__animated animate__fadeOutDown",
});
